import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import Row from 'components/list/Filters/layout/Row';
import { Field, getFormValues, reduxForm, change } from 'redux-form';
import { Section } from 'components/ui/table/elements';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { parseResourceId, stringifyResourceId } from 'helpers/product';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';

class MultiFieldResource extends Component {
    componentDidMount() {
        const {
            fields,
            initialize,
            input: {
                value,
            },
        } = this.props;

        if (value.length) {
            initialize(parseResourceId(value));
        } else if (!utils.isEmpty(fields)) {
            const initialValues = {};

            utils.each(fields, (value, key) => {
                initialValues[key] = null;
            });

            initialize(initialValues);
        }
    }

    componentDidUpdate(prevProps) {
        const { valid } = this.props;

        if (prevProps.valid && !valid) {
            this.invalidateForm();
        }
    }

    onChange(event, newValue, previousValue, name) {
        const { formValues, input, valid, updateResourceForm } = this.props;

        if (valid) {
            const updatedFormValues = {
                ...formValues,
                [name]: newValue,
            };

            updateResourceForm(input.name, stringifyResourceId(updatedFormValues));
        } else {
            this.invalidateForm();
        }
    }

    onBlur() {
        const { formValues, input, valid, updateResourceForm } = this.props;

        if (valid) {
            updateResourceForm(input.name, stringifyResourceId(formValues));
        } else {
            this.invalidateForm();
        }
    }

    invalidateForm() {
        const { input, updateResourceForm } = this.props;

        updateResourceForm(input.name, '');
    }

    render() {
        const {
            fields,
            fullWidth,
            input,
            label,
            meta,
            translate,
        } = this.props;

        if (utils.isEmpty(fields)) {
            return (
                <Section style={ { maxWidth: '50%' } }>
                    <Row>
                        <Field
                            component={ RenderTextInputField }
                            fullWidth={ fullWidth }
                            input={ input }
                            label={ label }
                            meta={ meta }
                            name={ input.name }
                            validate={ [
                                validations.required,
                            ] }
                        />
                    </Row>
                </Section>
            );
        }

        return (
            <Section>
                {
                    utils.map(fields, (fieldObject, name) => {
                        const {
                            component = RenderTextInputField,
                            validate = [
                                validations.required,
                            ],
                        } = fieldObject;

                        return (
                            <Row key={ `resource-id-field-${ name }` }>
                                <Field
                                    component={ component }
                                    label={ translate(`resources.products.fields.${ name }`) }
                                    name={ name }
                                    onBlur={ () => {
                                        return this.onBlur();
                                    } }
                                    onChange={ (event, newValue, previousValue, name) => {
                                        return this.onChange(event, newValue, previousValue, name);
                                    } }
                                    style={ { minWidth: '50%' } }
                                    validate={ validate }
                                />
                            </Row>
                        );
                    })
                }
            </Section>
        );
    }
}

MultiFieldResource.propTypes = {
    fields: PropTypes.objectOf(PropTypes.shape({
        component: PropTypes.node,
        validate: PropTypes.arrayOf(PropTypes.string),
    })).isRequired,
    formValues: PropTypes.object,
    fullWidth: PropTypes.bool,
    initialize: PropTypes.func,
    input: PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string,
    }),
    label: PropTypes.string,
    meta: PropTypes.object,
    updateResourceForm: PropTypes.func,
    valid: PropTypes.bool,
    translate: PropTypes.func,
};

const mapStateToProps = (state) => {
    const form = 'resource_id';

    return {
        form: form,
        formValues: getFormValues(form)(state),
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        updateResourceForm: (field, value) => {
            dispatch(change(props.meta.form, field, value));
        },
    };
};

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    translate,
    reduxForm(),
);

export default enhance(MultiFieldResource);



// WEBPACK FOOTER //
// ./src/pages/products/resource/fields/MultiFieldResource.js